import { inject, Injectable } from '@angular/core';
import { PreferencesService } from '../preferences.service';

const ONBOARDING_SEEN_KEY = 'hasSeenOnboarding';

@Injectable({
  providedIn: 'root',
})
export class OnboardingService {
  private preferencesService = inject(PreferencesService);

  async hasSeenOnboarding(): Promise<boolean> {
    const value = await this.preferencesService.get(ONBOARDING_SEEN_KEY);
    return value === 'true';
  }

  async markOnboardingAsSeen(): Promise<void> {
    await this.preferencesService.set(ONBOARDING_SEEN_KEY, 'true');
  }

  async resetOnboarding(): Promise<void> {
    await this.preferencesService.delete(ONBOARDING_SEEN_KEY);
  }
}
